<template>
  <div class="">
    <div v-if="isShow" class="pt16 pb16 bg_white">
      <PageBack class="pl16" />
      <SectionTitle
      class="mt16"
      :title="'購入人数詳細'"
      :width="'116'"
      />
      <div class="calendar_head ml16 mr16">
        <div class="current_date rb c5a">{{ targetYear }}<span class="year ab">年</span>{{ targetMonth }}<span class="month ab">月</span>{{ targetDay }}<span class="month ab">日</span></div>
      </div>
      <div class="nds_wrap mt24">
        <SectionTitle
        :title="'顧客性別'"
        :width="'116'"
        />
        <div class="table_wrap ml16 mr16">
          <table class="table row3">
            <thead>
              <tr class="table_row">
                <th class="table_th rr">性別</th>
                <th class="table_th rr">購入人数</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="val in sexSummaryList" class="table_row">
                <th class="rr table_th">{{ val.key }}</th>
                <td class="rr table_td">{{ val.value }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="nds_wrap mt24">
        <SectionTitle
        :title="'顧客年齢'"
        :width="'116'"
        />
        <div class="table_wrap ml16 mr16">
          <table class="table row2">
            <thead>
              <tr class="table_row">
                <th class="table_th rr">顧客年齢</th>
                <th class="table_th rr">購入人数</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="val in ageSummaryList" v-show="val.value > 0" class="table_row">
                <th class="table_th rr">{{ val.key }}</th>
                <td class="table_td rr">{{ val.value }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="nds_wrap mt24">
        <SectionTitle
        :title="'都道府県別購入人数'"
        :width="'167'"
        />
        <div v-for="val in prefectureSummaryList">
          <h2 v-if="val.prefectureSummaryList.length > 0" class="page_title rb c5a ml16 mt16 mr16">{{ val.areaName }}</h2>
          <div v-if="val.prefectureSummaryList.length > 0" class="table_wrap ml16 mr16">
            <table class="table row2">
              <thead>
                <tr class="table_row">
                  <th class="table_th rr">都道府県別購入人数</th>
                  <th class="table_th rr">購入人数</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="data in val.prefectureSummaryList" v-show="data.value > 0" class="table_row">
                  <th class="table_th rr">{{ data.key }}</th>
                  <td class="table_td rr">{{ data.value }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <ErrorModal v-if="isErrorModal" :errorMessage="errorMessage" @modalClose="modalClose" />
    </div>
    <div v-else class="bg_white pt16 pb16 pl16 pr16 ab">アクセスエラー<br>coNPusアプリから再度開き直してください。</div>
  </div>
</template>

<script>
import Check from '@/model/getToken';
import Wallet from '@/components/api/wallet/wallet';
import SectionTitle from '@/components/common/SectionTitle';
import PageBack from '@/components/wallet/PageBack';
import ErrorModal from '@/components/common/ErrorModal';

export default {
  components: {
    SectionTitle,
    PageBack,
    ErrorModal
  },
  data() {
    return {
      isShow: true,
      targetYear: '',
      targetMonth: '',
      targetDay: '',
      sexSummaryList: [],
      ageSummaryList: [],
      prefectureSummaryList: [],
      isErrorModal: false,
      errorMessage: '',
    }
  },
  methods: {
    modalClose() {
      this.isErrorModal = false;
    },
    async getSalesSummaryDetailDaily() {
      await Wallet.getSalesSummaryDetailDaily(this.$route.query.affiliateProductId, this.$route.query.targetYmd).then((val) => {
        console.log('getSalesSummaryDetailDaily');
        console.log(val);
        // if(!val) {
        //   console.log('error');
        //   this.errorMessage = 'エラーが発生しました。しばらくたってから、再度実行してください。';
        //   this.isErrorModal = true;
        // } else {
          this.targetYear = val.targetYear;
          this.targetMonth = val.targetMonth;
          this.targetDay = val.targetDay;
          this.sexSummaryList.push(...val.sexSummaryList);
          this.ageSummaryList.push(...val.ageSummaryList);
          this.prefectureSummaryList.push(...val.prefectureSummaryList);
        // }

      });
    },
  },
  async created() {
    let res;
    await Check.checkRequest(this.$route.query.code).then((val) => { res = val; });
    if(res) {
      this.getSalesSummaryDetailDaily();
    } else {
      this.isShow = false;
    }
  }
}
</script>

<style lang="css" scoped>
.calendar_head {
  align-items: center;
  display: flex;
  border-bottom: 1px solid  #c9c9c9;
  justify-content: center;
  line-height: 1;
  padding: 24px 6px 14px 6px;
}
.current_date {
  font-size: 22px;
}
.year, .month {
  font-size: 16px;
}
.year {
  margin: 0 2px;
}

.table_wrap {
  margin-top: 8px;
}
.table {
  border-collapse: separate;
  border-radius: 6px;
  overflow: hidden;
  width: 100%;
}
.table_th,
.table_td {
  border: 1px solid  #fff;
  font-size: 12px;
  padding: 8px;
  text-align: center;

}
.row3 .table_th, .row3 .table_td {
  width: 33%;
}
.row2 .table_th, .row2 .table_td {
  width: 50%;
}
.table_th {
  background-color: #7187E5;
  color: #fff;
}
.table_td {
  background-color: #f9f9f9;
}

.table thead .table_th:first-child {
	border-radius: 6px 0 0 0;
}
.table thead .table_th:last-child {
	border-radius:0 6px 0 0;
}
.table tbody .table_row:last-child .table_th:first-child {
	border-radius: 0 0 0 6px;
}
.table tbody .table_row:last-child .table_td:last-child{
	border-radius: 0 0 6px 0;
}
</style>



// WEBPACK FOOTER //
// src/views/wallet/salesSummaryReport/NdsDetail.vue